import { createContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// material-ui

// project imports
import { useSelector, RootState, dispatch } from "store";
import { login, logout, initialState, checkLogin, AuthState } from "store/slices/auth";
import LoginModal from "ui-component/LoginModal";
import useLog from "hooks/useLog";
import { getQueryVariable } from "utils";

// ==============================|| FIREBASE CONTEXT & PROVIDER ||============================== //
export interface AuthContextType extends AuthState {
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({ ...initialState, login: () => dispatch(login()), logout: () => dispatch(logout()) });

interface AuthContextProviderProps {
  children: React.ReactNode;
}

export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
  const auth = useSelector((state: RootState) => state.auth);
  const log = useLog();
  const [searchParams, setSearchParams] = useSearchParams();
  const utmCampaign = searchParams.get("utm_campaign");
  const openid = getQueryVariable("openid");
  const login_id = searchParams.get("login");

  useEffect(() => {
    dispatch(
      checkLogin(() => {
        const params: { [key: string]: string } = {};
        searchParams.forEach((value, key) => {
          if (key !== "openid" && login_id !== "login") {
            params[key] = value;
          }
        });

        setSearchParams({
          ...params
        });

        log("open_function_page", {
          source: utmCampaign || "",
          path: window.location.href
        });

        if (openid) {
          log("account_login", {
            login_type: 1
          });
        }

        if (login_id) {
          log("account_login", {
            login_type: 2
          });
        }
      })
    );
  }, []);

  return (
    <AuthContext.Provider
      value={{
        ...auth,
        login: () => dispatch(login()),
        logout: () => dispatch(logout())
      }}
    >
      {children}
      <LoginModal />
    </AuthContext.Provider>
  );
};

export default AuthContext;
